import { useEffect, useState } from 'react';

import { getCompany } from '../services/companiesService';
import { CompanyDetails } from '../types';

export const useCompany = (companyUuid?: string | null) => {
  const [company, setCompany] = useState<CompanyDetails | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCompany = async (uuid: string) => {
    try {
      setLoading(true);
      setError(null);
      const data = await getCompany(uuid);
      setCompany(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao buscar company');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyUuid) {
      fetchCompany(companyUuid);
    }
  }, [companyUuid]);

  const refetch = () => {
    if (companyUuid) {
      fetchCompany(companyUuid);
    }
  };

  return {
    company,
    loading,
    error,
    refetch,
  };
};
